import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBanners } from "../actions/banners";
import { dataUrl, getAssetsByName } from "./common";

const WebsiteLogo = ({ height = "auto" }) => {
  const rawAssets = useSelector((state) => state.banners["assets"]);

  // Ensure 'assets' is a flat array even if the API returns { data: [...] }
  const assets = Array.isArray(rawAssets) ? rawAssets : rawAssets?.data || [];

  // FIX: Added .toLowerCase() check to match your API response "website logo"
  const websiteLogo = assets.find(
    (item) => item.name?.toLowerCase() === "website logo",
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBanners("assets"));
  }, [dispatch]);

  return (
    <>
      {/* FIX: Only render the img if websiteLogo exists to prevent the "undefined" URL error */}
      {websiteLogo?.image && (
        <img
          // ✅ Direct access to the working full URL string path field from your API payload
          src={websiteLogo?.imageUrl}
          height={height}
          alt="jobseeker-website-logo"
          className="logo-dark"
          // ✅ Keeps the security guard intact if your backend server triggers cross-origin hotlink protections
          referrerPolicy="no-referrer"
        />
      )}
    </>
  );
};

export default WebsiteLogo;
